import Reveal from "./Reveal";
import { useContent } from "../content";

const SPANS = [
  "sm:col-span-2 sm:row-span-2",
  "sm:col-span-1",
  "sm:col-span-1",
  "sm:col-span-1",
  "sm:col-span-1",
];

export default function Gallery() {
  const items = useContent().gallery || [];
  if (items.length === 0) return null;
  return (
    <section id="realisations" className="relative bg-[#050505] py-24 sm:py-32" data-testid="gallery-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal className="mb-16 flex flex-col justify-between gap-6 sm:flex-row sm:items-end">
          <div>
            <span className="text-xs font-semibold uppercase tracking-[0.25em] text-white/50">
              Nos réalisations
            </span>
            <h2 className="mt-4 font-head text-4xl font-semibold uppercase tracking-tight text-white sm:text-5xl md:text-6xl">
              Le terrain,<br /><span className="text-gradient">en images</span>
            </h2>
          </div>
          <p className="max-w-sm text-sm font-light leading-relaxed text-white/60">
            Chantiers de maintenance et productions événementielles — un aperçu de
            notre savoir-faire multitechnique.
          </p>
        </Reveal>

        <div className="grid auto-rows-[220px] grid-cols-1 gap-4 sm:grid-cols-3">
          {items.map((g, i) => (
            <Reveal
              key={g.title + i}
              delay={i * 0.05}
              className={`group relative overflow-hidden rounded-md border border-white/10 ${SPANS[i] || ""}`}
              data-testid={`gallery-item-${i}`}
            >
              <img
                src={g.img}
                alt={g.title}
                className="h-full w-full object-cover brightness-[0.45] saturate-[0.7] transition-all duration-700 group-hover:scale-105 group-hover:brightness-100 group-hover:saturate-100"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
              <div className="absolute bottom-0 left-0 p-5">
                <span className="text-[10px] font-semibold uppercase tracking-[0.2em] text-[#ff8c8c]">
                  {g.tag}
                </span>
                <h3 className="font-head text-xl font-medium uppercase tracking-tight text-white">
                  {g.title}
                </h3>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
